import { useApiUtils } from '@core/util/apiUtils';
import { Button, CircularProgress } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import CloudDownloadIcon from '@material-ui/icons/CloudDownload';
import HighlightOffIcon from '@material-ui/icons/HighlightOff';
import PrintIcon from '@material-ui/icons/Print';
import { publicoApi } from 'app/services/api/publicoApi';
import * as Actions from 'app/store/actions';
import React, { useEffect, useState } from 'react';
import { Document, Page } from 'react-pdf/dist/esm/entry.webpack';
import 'react-pdf/dist/esm/Page/AnnotationLayer.css';
import { useDispatch } from 'react-redux';

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
    margin: 'auto',
  },
  containerButton: {
    marginRight: 'auto',
    '@media (min-width: 900px)': {
      marginLeft: '50px',
      float: 'right',
      position: 'relative',
    },
  },
  button: {
    background: '#00afb4',
    color: '#fff',
    width: 125,
    height: 50,
    marginBottom: 10,
    marginLeft: 10,
    borderRadius: 5,
    fontSize: 14,
    textTransform: 'capitalize',
    '&:hover': {
      background: '#00afb4',
    },
  },
  containerPDF: {
    float: 'right',
    position: 'relative',
  },
  documentPDF: {
    boxShadow: '0px 5px 5px -3px rgba(0,0,0,0.2), 0px 8px 10px 1px rgba(0,0,0,0.14), 0px 3px 14px 2px rgba(0,0,0,0.12)',
    marginBottom: '10px',
  },
}));

const options = {
  cMapUrl: 'cmaps/',
  cMapPacked: true,
};

const Visualizador = () => {
  const classes = useStyles();

  const [arquivo, setArquivo] = useState('');
  const [nomeArquivo, setNomeArquivo] = useState('');
  const [numPages, setNumPages] = useState(null);
  const [loading, setLoading] = useState(false);
  const [timeout, setTimeout] = useState(false);

  const dispatch = useDispatch();
  const apiUtils = useApiUtils(dispatch, Actions);

  useEffect(() => {
    const buscarRelatorio = async () => {
      try {
        setLoading(true);
        var response;
        const urlParams = new URLSearchParams(window.location.search);
        const chaveFiltro = atob(urlParams.get('key'));
        const tenant = atob(urlParams.get('t'));

        if (urlParams.get('g') !== null) {
          const gestaoEnvioId = atob(urlParams.get('g'));
          response = await publicoApi().getRelatorioPdf(chaveFiltro, tenant, gestaoEnvioId);
        } else {
          response = await publicoApi().getRelatorioPdf(chaveFiltro, tenant);
        }

        setArquivo(response?.data?.arquivo);
        setNomeArquivo(response?.data?.nome);
        setLoading(false);
      } catch (error) {
        setTimeout(true);
        setLoading(false);
        apiUtils.handleApiError(error);
      }
    };

    buscarRelatorio();
    // Efeito de montagem: roda uma única vez. Incluir as dependências reexecutaria a carga
    // inicial a cada render (loop de chamadas à API).
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function onDocumentLoadSuccess(documentProps) {
    setNumPages(documentProps.numPages);
  }

  const downloadPDF = () => {
    const linkSource = `data:application/pdf;base64,${arquivo}`;
    const downloadLink = document.createElement('a');

    downloadLink.href = linkSource;
    downloadLink.download = `${nomeArquivo}.pdf`;
    downloadLink.click();
  };

  function closePrint() {
    document.body.removeChild(this.__container__);
  }

  function setPrint() {
    this.contentWindow.__container__ = this;
    this.contentWindow.onbeforeunload = closePrint;
    this.contentWindow.onafterprint = closePrint;
    this.contentWindow.focus(); // Required for IE
    this.contentWindow.print();
  }

  function printPage(sURL) {
    const hideFrame = document.createElement('iframe');
    hideFrame.onload = setPrint;
    hideFrame.style.position = 'fixed';
    hideFrame.style.right = '0';
    hideFrame.style.bottom = '0';
    hideFrame.style.width = '0';
    hideFrame.style.height = '0';
    hideFrame.style.border = '0';
    hideFrame.src = sURL;
    document.body.appendChild(hideFrame);
  }

  function closeWindow() {
    // window.history.back();
    window.close();
  }

  const printPDF = () => {
    // converts base64 to blob type for windows
    function pdfBlobConversion(b64Data, contentType) {
      contentType = contentType || '';
      const sliceSize = 512;
      b64Data = b64Data.replace(/^[^,]+,/, '');
      b64Data = b64Data.replace(/\s/g, '');
      const byteCharacters = window.atob(b64Data);
      const byteArrays = [];

      for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
        const slice = byteCharacters.slice(offset, offset + sliceSize);

        const byteNumbers = new Array(slice.length);
        for (let i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i);
        }

        const byteArray = new Uint8Array(byteNumbers);

        byteArrays.push(byteArray);
      }

      const blob = new Blob(byteArrays, { type: contentType });
      return blob;
    }

    const file = pdfBlobConversion(arquivo, 'application/pdf');
    const fileURL = URL.createObjectURL(file);
    //const myWindow = window.open(fileURL);
    //myWindow.print();
    printPage(fileURL);
  };

  return (
    <div className={classes.root}>
      {!timeout && (
        <div className={classes.containerButton}>
          <div>
            <Button
              variant="contained"
              className={classes.button}
              onClick={downloadPDF}
              startIcon={<CloudDownloadIcon />}
            >
              Baixar
            </Button>
          </div>
          <div>
            <Button variant="contained" className={classes.button} onClick={printPDF} startIcon={<PrintIcon />}>
              Imprimir
            </Button>
          </div>
          <div>
            <Button
              variant="contained"
              className={classes.button}
              onClick={closeWindow}
              startIcon={<HighlightOffIcon />}
            >
              Fechar
            </Button>
          </div>
        </div>
      )}

      <div className={classes.containerPDF}>
        {loading && <CircularProgress size={80} style={{ color: '#00afb4' }} />}
        {arquivo && (
          <Document
            file={`data:application/pdf;base64,${arquivo}`}
            onLoadSuccess={onDocumentLoadSuccess}
            options={options}
          >
            {Array.from(new Array(numPages), (el, index) => (
              <Page key={`page_${index + 1}`} pageNumber={index + 1} className={classes.documentPDF} />
            ))}
          </Document>
        )}
      </div>
    </div>
  );
};

export default Visualizador;
